module.exports = __webpack_public_path__ + "img/10.742933cb.png";